import { createSlice } from "@reduxjs/toolkit";

const contestSlice = createSlice({
  name: "contestSlice",
  initialState: {
    isLoading: false,
    contestList: [],
    activeContests: [],
    selectedContestIds: [],
    voteHistory: [],
    pagination: {
      page: 1,
      limit: 10,
      total: 0,
    },
  },
  reducers: {
    getContestListRequest: {
      reducer: (state) => {
        state.isLoading = true;
        return state;
      },
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    getContestListSuccess: {
      reducer: (state, action) => {
        console.log(action.payload, "action.payload");
        return {
          ...state,
          isLoading: false,
          contestList: action.payload?.docs || [],
          pagination: {
            page: action.payload.page || 1,
            limit: action.payload.limit || 10,
            total: action.payload.totalDocs || 0,
          },
        };
      },
      prepare: (payload, meta) => ({ payload, meta }),
    },
    createContestRequest: {
      reducer: (state) => {
        state.isLoading = true;
        return state;
      },
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    createContestSuccess: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    updateContestRequest: {
      reducer: (state) => {
        state.isLoading = true;
        return state;
      },
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    updateContestSuccess: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    deleteContestRequest: {
      reducer: (state) => {
        state.isLoading = true;
        return state;
      },
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    deleteContestSuccess: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    getContestDetailRequest: {
      reducer: (state) => {
        state.isLoading = true;
        return state;
      },
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    getContestDetailSuccess: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
        contestDetail: action.payload,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    setSelectedContestIds(state, action) {
      return {
        ...state,
        selectedContestIds: action.payload,
      };
    },
    stopLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },
    updateVotingLogicRequest: {
      reducer: (state) => {
        state.isLoading = true;
        return state;
      },
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    updateVotingLogicSuccess: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    getActiveContestsRequest: {
      reducer: (state) => {
        state.isLoading = true;
        return state;
      },
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    getActiveContestsSuccess: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
        activeContests: action.payload?.docs || [],
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
    getVoteHistoryRequest: {
      reducer: (state) => {
        state.isLoading = true;
        return state;
      },
      prepare: (payload) => ({ payload, meta: { thunk: true } }),
    },
    getVoteHistorySuccess: {
      reducer: (state, action) => ({
        ...state,
        isLoading: false,
        voteHistory: action.payload?.docs || [],
        pagination: {
          page: action.payload.page || 1,
          limit: action.payload.limit || 10,
          total: action.payload.totalDocs || 0,
        },
      }),
      prepare: (payload, meta) => ({ payload, meta }),
    },
  },
});

export const {
  getContestListRequest,
  getContestListSuccess,
  createContestRequest,
  createContestSuccess,
  updateContestRequest,
  updateContestSuccess,
  deleteContestRequest,
  deleteContestSuccess,
  getContestDetailRequest,
  getContestDetailSuccess,
  setSelectedContestIds,
  stopLoading,
  updateVotingLogicRequest,
  updateVotingLogicSuccess,
  getActiveContestsRequest,
  getActiveContestsSuccess,
  getVoteHistoryRequest,
  getVoteHistorySuccess,
} = contestSlice.actions;

export default contestSlice.reducer;
